
import React from 'react';
import BlockIcon from '@mui/icons-material/Block';

const ErrorPage = () => {
 
  return (
    <div className="unauthorized">
      <div className='started'><BlockIcon/> Something went wrong</div>
      <div className='started'> <h3> Check your connection </h3></div>
    </div>
  );
};

export default ErrorPage;
